import { useCollection, useIO, useLinked, useModel } from "@type-r/react";
import { Loading } from "lqx-react";
import React from "react";
import { getUserDetail } from "src/app/services/can";
import { AssetType } from "../../api/assetType";
import { Company } from "../../api/company";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ImportTemplatesLookup } from "../../api/lookups";
import { ManualCreditNote } from "../../api/manualCreditNote";
import { AddAssetsStep } from "../add-assets-step";
import { CreditNoteForm } from "./credit-note-form";

export const AddCreditNoteStep = ({ next, back, cancel, job }:
  { next?, back?, cancel?, job: IngestionJob }) => {
  const assetExtensions = "*.xlsx,*.xls,*.csv";
  const showDownloadTemplate = false;
  const userTemplates = useModel(ImportTemplatesLookup);
  const $dataHolderId = useLinked<Company>(new Company());
  const $allowedExtension = useLinked(assetExtensions);
  const $userTemplate = useLinked<{ id?: string }>(null)
    .onChange(x => applyImportTemplateExtension(x.id));
  //TODO we removed organizationId bacause organizationId from INBLOCK
  //const $organizationId = useLinked(localUserInfo.organization_id);

  const isReady = useIO(async () => {
    const params = { params: { assetTypeId: AssetType.creditNote } };
    await userTemplates.fetch(params).catch(e => console.error(e));
  }, []);

  const applyImportTemplateExtension = (userTemplateId) => {
    let importTemplateExtension: string;
    if (Boolean(userTemplateId) && Boolean(userTemplates)) {
      importTemplateExtension = userTemplates.items.find((item) => item.id === userTemplateId).originalFileName.split(".").pop();
      $allowedExtension.set(`*.${importTemplateExtension}`);
    } else {
      $allowedExtension.set(assetExtensions);
    }
  }

  return isReady ?
    <>
      <AddAssetsStep
        manualAssetModel={ManualCreditNote}
        assetName="Credit Note"
        $dataHolderId={$dataHolderId}
        userTemplates={userTemplates}
        $userTemplate={$userTemplate}
        allowedExtension={$allowedExtension.value}
        jobInfoProvider={() => ({ ...DocumentSource.CreditNote, userTemplateId: $userTemplate.value.id, dataHolderId: Boolean($dataHolderId.value) ? $dataHolderId.value.id : null })}
        showDownloadTemplate={showDownloadTemplate}
        assetForm={manualCreditNote => <CreditNoteForm creditNote={manualCreditNote}></CreditNoteForm>}
        next={next} back={back} cancel={cancel} job={job} />
    </> : <Loading />
};